import React from 'react';

const FreeShippingProgressBar = ({ isMiniCart }) => {
	return (
		<div
			className='free-shipping-progress-bar'
			data-free-shipping-threshold={window.pageContext.freeShippingThreshold}
			data-is-minicart={isMiniCart}
			id='FreeShippingProgressBar'
		>
			<p className='free-shipping-progress-bar__description'>
				<span className='free-shipping-progress-bar__description-under-threshold'>
					You&apos;re <span>{window.pageContext.freeShippingThreshold}</span> away from <em>free shipping</em>!
				</span>
				<span className='free-shipping-progress-bar__description-meets-threshold'>
					🎉 Congrats! You&apos;ve unlocked <em>free shipping</em>!
				</span>
			</p>
			<div className='free-shipping-progress-bar__bar'>
				<span className='free-shipping-progress-bar__start-label'>$0</span>
				<div className='free-shipping-progress-bar__track'>
					<span className='free-shipping-progress-bar__progress' />
				</div>
				<span className='free-shipping-progress-bar__finish-label'>
					${window.pageContext.freeShippingThreshold / 100}
				</span>
			</div>
		</div>
	);
};

export default FreeShippingProgressBar;
